<template>
  <SogCard>
    <SogCardTitle>
      {{ item.productName }}
    </SogCardTitle>
    <SogCardContent>
      {{ item.count }} Stk.
    </SogCardContent>
    <slot />
  </SogCard>
</template>

<script setup lang="ts">

import StoreItem from "@/shared/model/StoreItem";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";

interface Props {
  item:StoreItem
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {

  }
)




</script>

<style scoped>

</style>
